/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@apollo/client';
import { COMBO_STATION_QUERY } from './queries';

export const useComboStation = (comboStationId) => {
  const {
    error,
    loading,
    data,
  } = useQuery(COMBO_STATION_QUERY, {
    variables: {
      id: comboStationId,
    },
  });

  const comboStation = React.useMemo(() => {
    if (!loading && !error) {
      return data.viewer.device;
    }
    return null;
  }, [error, data, loading]);

  return {
    error,
    loading,
    comboStation,
  };
};
